// extracted by mini-css-extract-plugin
module.exports = {"container":"_1VE0tmHcTS0tLxM-23AMUl"};